import { render } from "./BnKvTable.vue?vue&type=template&id=6dc0ffbf"
import script from "./BnKvTable.vue?vue&type=script&lang=js"
export * from "./BnKvTable.vue?vue&type=script&lang=js"

import "./BnKvTable.vue?vue&type=style&index=0&id=6dc0ffbf&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__